import { EnhancedDesignType } from '../../../store/types/template';

export interface BatchesEnhancedDesignTemplateData {
  appleEnhancedDesign?: { type?: EnhancedDesignType | null } | null;
}

const FEATURED_ACTION_SAMPLE_VALUES: Record<string, string> = {
  featured_action_one_type: 'membershipBenefits',
  featured_action_one_url: 'https://example.com/membership',
  featured_action_two_type: 'viewOffersRewards',
  featured_action_two_url: 'https://example.com/offers',
};

export const enhancedDesignColumns = (
  templateData: BatchesEnhancedDesignTemplateData
): string[] => {
  const type = templateData.appleEnhancedDesign?.type;

  return [
    ...(type ? ['override_artwork_image_asset_id'] : []),
    ...(type === 'generic' ? Object.keys(FEATURED_ACTION_SAMPLE_VALUES) : []),
  ];
};

export const featuredActionSampleValue = (column: string): string | undefined =>
  FEATURED_ACTION_SAMPLE_VALUES[column];
